import axios from "axios";

import {
  CREATE_COMPONENT,
  GET_COMPONENTS,
  UPDATE_COMPONENT,
} from "actions/ActionTypes";
import { postApi, putApi } from "actions/SendActions";
import rootURL from "utils/RootURL";
import { formatHeaders } from "utils/Api";

export const fetchComponents = (token, projectSlug) =>
  postApi({
    endpoint: "/api/project/v3/admin/components",
    type: GET_COMPONENTS,
    item: "components",
    token,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    data: {
      indexes: ["uuid", "section", "platform"],
      nested: {
        dynamic_component: {},
        static_component: {},
      },
      page: 1,
      per_page: 10000,
    },
  });

export const createComponent = (component, token, projectSlug, t, callback) =>
  postApi({
    endpoint: "/api/project/v3/admin/components/create",
    type: CREATE_COMPONENT,
    item: "components",
    token,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    data: component,
    message: t?.("editor-notif:saveSuccess"),
    error: t?.("editor-notif:saveError"),
    callback,
  });

export const updateComponent = (component, token, projectSlug, t, callback) =>
  putApi({
    endpoint: `/api/project/v3/admin/components/${component.uuid}`,
    type: UPDATE_COMPONENT,
    item: "components",
    token,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    data: component,
    message: t("editor-notif:saveSuccess"),
    error: t("editor-notif:saveError"),
    callback,
  });

export const uploadWidget = (formData, token, projectSlug, callback) => {
  axios({
    url: rootURL("/api/project/v3/admin/components/upload_widget"),
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      ...formatHeaders(token, [
        {
          key: "xx-ok-project",
          value: projectSlug,
        },
      ]),
    },
    data: formData,
  }).then((response) => {
    callback?.(response);
  });
};
